import { render, staticRenderFns } from "./ota-upload-create.vue?vue&type=template&id=fcda935e&scoped=true&"
import script from "./ota-upload-create.vue?vue&type=script&lang=tsx&"
export * from "./ota-upload-create.vue?vue&type=script&lang=tsx&"
import style0 from "./ota-upload-create.vue?vue&type=style&index=0&id=fcda935e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcda935e",
  null
  
)

export default component.exports